export const getLang = () => {
  if (navigator.languages != undefined) return navigator.languages[0];
  return navigator.language;
};

export const whatDecimalSeparator = () => {
  const n = 1.1;
  const s = n.toLocaleString().substring(1, 2);
  return s;
};

export const isEmpty = (obj: any) => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }
  return true;
};

export const uuidv4 = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (
      +c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
    ).toString(16)
  );
};

export const nFormatter = (bigint: bigint, digits: number, decimals = 8) => {
  const num = Number(bigint) / 10 ** decimals;
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });

  return item
    ? (num / item.value).toLocaleDecimal(digits).replace(rx, "$1") + item.symbol
    : num
      ? num.toLocaleDecimal(digits).replaceAll(/\.[0]+$/g, "")
      : "0";
};

export const nFormatterInt = (num: number, digits: number) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });

  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export interface Apr {
  value: string | null | undefined;
  status: "AVAILABLE" | "NOT_APPLICABLE" | "SOON" | "%future added value";
}

export const formatApr = (apr: Apr | null | undefined): string => {
  if (!apr) return "—";

  if (apr.status === "SOON") return "Soon";
  if (apr.status === "NOT_APPLICABLE") return "N/A";

  if (apr.value === null) return "—";
  if (apr.value === undefined) return "—";

  return `${nFormatter(BigInt(apr.value), 2, 10)}%`;
};

export const classApr = (apr: Apr | null | undefined): string => {
  if (!apr) return "color-grey";

  if (apr.status === "SOON") return "color-white";
  if (apr.status === "NOT_APPLICABLE") return "color-grey";

  if (apr.value === null) return "color-grey";
  if (apr.value === undefined) return "color-grey";

  if (Number(apr.value) >= 0) return "color-teal";
  return "color-red";
};
